var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"text-copy"},[_c('span',{staticClass:"text-content text-overflow-ellipsis"},[_vm._v(_vm._s(_vm.value))]),_c('i',{staticClass:"copy-icon ws-icon-connection",attrs:{"title":_vm.$t('common.clickCopy')},on:{"click":function($event){return _setup.clip(_vm.value, $event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }